
import { ENV } from "../../../../config/config"
import { Link, useLocation, useHistory } from 'react-router-dom';
import { showNotePopup, RegisterUser, getUnseenEvents, getUserStatus, getNotifications } from "../../../../redux/user/action"
import { getActivityPopups, updateActivity, verifyActivity, acknowledgeActivity } from "../../../../redux/activity/action"
import { clearCurrentUser } from "../../../../redux/walletProviders/action"
import { FaVideo, FaRegHandSpock } from 'react-icons/fa';
import { BsCurrencyBitcoin } from 'react-icons/bs';
import { GiOpenTreasureChest } from "react-icons/gi";
import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux";
import NotesModal from '../../../specialNotes';
import { useDisconnect } from "wagmi";
import { notify } from "react-notify-toast";
import Swal from 'sweetalert2';
import SuccessPop from "../../../successPopup/successPop"
import ActivityPopup from "../../../activityPopup/activityPopup"
import { useIdleTimer } from 'react-idle-timer'

const { socket } = ENV

function Sidebar(props) {
    let location = useLocation();

    let searchParams = new URLSearchParams(location.search)
    let walletAddress = useSelector(state => state?.walletProvider?.currentUser) || ENV.getUserKey("WalletAddress")
    let dotShow = localStorage.getItem("showDot")
    const user = useSelector(state => state.userData?.profile)
    let userId = searchParams.get('userId')
    let address = searchParams.get('address')
    let code = searchParams.get('code')
    const { disconnect } = useDisconnect();
    const unreadNotifications = useSelector(state => state.userData.unreadNotifications)

    const points = useSelector(state => state.userData.points)
    const nftsRes = useSelector(state => state.userData.nfts)
    const unseenEvents = useSelector(state => state.userData.unseenEvents)
    const showNotificationPopup = useSelector(state => state.userData.showNotificationPopup)
    const popups = useSelector(state => state.popups.popups)
    const activePopup = useSelector(state => state.popups.popupToShow)
    const acknowledged = useSelector(state => state.popups.acknowledgeActivity)

    const history = useHistory()
    const pathname = window.location?.pathname
    const [showActivityPopup, setShowActivityPopup] = useState(true)
    const [toggle, settoggle] = useState(0);
    const [showPopup, setShowPopup] = useState(false)
    const dispatch = useDispatch();
    const [wallet, setWallAddress] = useState()
    const [showDot, setShowDot] = useState(false)
    const [notesModal, setNotesModal] = useState(false);
    const [popupData, setPopupData] = useState("")
    const [state, setState] = useState('Active')
    const [count, setCount] = useState(0)
    const [remaining, setRemaining] = useState(0)
    useEffect(async () => {
        if (dotShow == true || dotShow == false) {
            setShowDot(Boolean(dotShow))
        }
    }, [])
    // useEffect(async () => {
    //     if (walletAddress) {
    //         setWallAddress(walletAddress)

    //         dispatch(getActivityPopups())


    //     }
    // }, [walletAddress])
    const onIdle = () => {
        setState('Idle')
    }

    const onActive = () => {
        setState('Active')
    }

    const onAction = () => {
        setCount(count + 1)
    }

    const { getRemainingTime } = useIdleTimer({
        onIdle,
        onActive,
        onAction,
        timeout: 10_000 * (7 * (60 / 10)),
        throttle: 500
    })

    useEffect(() => {
        const interval = setInterval(() => {
            setRemaining(Math.ceil(getRemainingTime() / 1000))
            if (remaining == 1) {
                logout()
            }
        }, 500)

        return () => {
            clearInterval(interval)
        }
    })

    useEffect(() => {
        socket.on("event_created", (data) => {
            setShowDot(true)
            dispatch(getUnseenEvents(wallet))
        })
    }, [socket])

    useEffect(() => {
        socket.on("daliy claim", (data) => {
            dispatch(getUserStatus({ address: walletAddress, platform: "Gamification" }))
            if (data.userId == walletAddress) {
                localStorage.setItem("showDot", true)
                setShowDot(true)
                dispatch(getNotifications(walletAddress))
                dispatch(showNotePopup(true))
                setPopupData(data)
            }
        })
        socket.on("referring", (data) => {
            if (data.address == walletAddress) {
                localStorage.setItem("showDot", true)
                setShowDot(true)
                dispatch(showNotePopup(true))

                dispatch(getNotifications(walletAddress))
                setPopupData(data)
            }
        })
        socket.on("dynamic tasks", (data) => {
            
        console.log(data,'sockettttttttttttttttt')
            if (data.userId == walletAddress) {
                dispatch(showNotePopup(true))
                setPopupData(data)
                localStorage.setItem("showDot", true)
                setShowDot(true)
                dispatch(getNotifications(walletAddress))

            }
        })
        socket.on("weekly earner", (data) => {
            if (data.userId == walletAddress) {
                localStorage.setItem("showDot", true)
                setShowDot(true)
                dispatch(showNotePopup(true))
                setPopupData(data)

                dispatch(getNotifications(walletAddress))
            }
        })
    }, [socket, showNotificationPopup])
    const Register = async (ref) => {
        const data = {
            name: "",
            image: "",
        }
        // if (code) {
        //     data.inviteeCode = code
        // }
        if (address) {
            data.address = walletAddress ? walletAddress : address
        } else {
            if (userId) {
                data.userId = userId
                localStorage.setItem("userId", userId)
            }
        }
        data.inviteeCode = code ? code : ""
        if (ref.includes('hex-nft.arhamsoft.org')) {
            data.address = address
        } else if (ref.includes('myntist.com')) {
            data.userId = userId
        } else {
            if (!walletAddress && !userId && !window.ethereum.selectedAddress) {
                history.push("/")
            }
        }
        if (userId || address) {
            dispatch(RegisterUser(data))
        }

    }
    useEffect(() => {
        if (walletAddress && user != undefined && (user?.name == undefined || user?.name == "" || user?.email == undefined || user?.email == "")) {
            history.push(`/settings?route=Settings&&signup=${user?.name && user?.email ? false : true}`)
        }
    }, [user])
    const checkWallet = () => {
        if (!walletAddress || walletAddress == "null") {
            setTimeout(() => {
                history.push("/");
            }, 500)
        }
    }

    const logout = () => {
        dispatch(clearCurrentUser());
        localStorage.setItem("logout", true);
        disconnect();
        localStorage.removeItem('token');
        localStorage.removeItem('WalletAddress')
        localStorage.removeItem("twitter_user_secret")
        localStorage.removeItem("twitter_user_token")
        history.push('/login');
    }

    const specialNotesModal = () => {
        setNotesModal(true);
    }

    const notesModalClose = (index) => {
        setNotesModal(false);
    }
    const handleNotifications = () => {
        setShowDot(false)
        localStorage.setItem("showDot", false)

    }
    const updatePopupAcknowledged = (acknowledged) => {
        dispatch(updateActivity({ acknowledged: acknowledged, name: popups[0]?.name }, popups[0]?._id))
    }

    let matchingPopup = user?.popup?.find((obj1) => {
        return popups?.some((obj2) => {
            return obj1.name === obj2.name && obj1.show == true && obj2.platforms == obj1.platform;
        });
    });
    // let popupToShow = popups?.find((obj1) => {
    //     return user?.popup?.some((obj2) => {
    //         return obj1.name === obj2.name && obj2.show == true && obj1.platforms == obj2.platform;
    //     });
    // });
    // let matchingValue = {}
    // if (popupToShow) {
    //     matchingValue = user?.popup?.find((obj) => {
    //         return obj.name === popupToShow.name && obj.show == true
    //             && popupToShow.platforms.toLowerCase() == obj.platform;
    //     });
    // }

    useEffect(() => {
        const interval = setInterval(async () => {

            // if (activePopup) {
            let verifyData = {
                address: walletAddress,
                acknowledged: false
            }
            dispatch(verifyActivity(verifyData))
            dispatch(getUserStatus({ address: walletAddress, platform: "Gamification" }))
            setShowPopup(true)
        }, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, [acknowledged])

    useEffect(() => {
        metamaskEventDetector();
    }, [window.ethereum])

    const metamaskEventDetector = async () => {
        if (window.ethereum) {
            window.ethereum.on('accountsChanged', (accounts) => {
                dispatch(clearCurrentUser());
                disconnect();
                logout()
            })
            window.ethereum.on('disconnect', () => {
                dispatch(clearCurrentUser());
                disconnect();
                logout()
            })
            return true;
        }
        else {
            return false;
        }
    }
    return (
        <>
            {
                user?.email !== '' && user?.email !== undefined && activePopup !== undefined && activePopup !== null && activePopup?.show == true && showPopup == true ?
                    <ActivityPopup popups={activePopup} popupData={activePopup} setShowPopup={setShowPopup} />
                    : ""
            }

            <div className={`sidebar ${toggle ? 'active ' : ''}`}>
                {showNotificationPopup == true ?
                    <SuccessPop popupData={popupData} />
                    : ""}

                <div className="sidebar-wrap">
                    <button className="toggle-button" onClick={() => settoggle(!toggle)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    <Link to={`/dashboard?address=${walletAddress}`} className="logo-link">
                        <div className="logo">
                            <div className="image">
                                <img src="/images/logo.svg" alt="" className="img-fluid" />
                            </div>
                            <div className="name">
                                <h5>Myntist</h5>
                                <span>Gamification Dashboard</span>
                            </div>
                            {/* <button className="toggle-button" onClick={() => settoggle(!toggle)}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </button> */}
                        </div></Link>
                    <div className="sidebar-links">
                        <ul>
                            <li>
                                <Link to={`/dashboard?address=${walletAddress}`} className={
                                    pathname.includes('dashboard') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>
                                    <span className="icon" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28" viewBox="0 0 26 28">
                                            <g id="Group_29" data-name="Group 29" transform="translate(-2.333 0.5)">
                                                <path id="Stroke_1" data-name="Stroke 1" d="M0,.5H7.753" transform="translate(11.457 17.888)" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                                <path id="Stroke_2" data-name="Stroke 2" d="M0,15.227C0,7.907.769,8.418,4.906,4.433,6.716,2.92,9.533,0,11.965,0s5.3,2.906,7.13,4.433C23.233,8.418,24,7.907,24,15.227,24,26,21.548,26,12,26S0,26,0,15.227Z" transform="translate(3.333 0.5)" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                            </g>
                                        </svg>
                                    </span><span>Dashboard</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={`/leaderboard?route=Leaderboard`} className={
                                    pathname.includes('leaderboard') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>
                                    <span className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28" viewBox="0 0 26 28">
                                            <g id="Group_32" data-name="Group 32" transform="translate(-2.333 -68)">
                                                <path id="Path_30" data-name="Path 30" d="M3.333,81.729h7v-13h10v9h7v17h-24Z" transform="translate(0 0.271)" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                                <path id="Path_31" data-name="Path 31" d="M10.35,74.863V95" transform="translate(10)" fill="none" stroke="#ffffff" strokeWidth="2" />
                                                <path id="Path_33" data-name="Path 33" d="M10.35,74.863V95" fill="none" stroke="#ffffff" strokeWidth="2" />
                                            </g>
                                        </svg>
                                    </span><span>Leaderboard</span>
                                </Link>
                            </li>
                            <li>
                                {/* <Link to="https://hex-nft.arhamsoft.org/author/624a83554224d142b3b49c93"> */}
                                {/* {nftsRes?.success == true ?
                                :
                            } */}
                                <a href={nftsRes?.success == true ? nftsRes?.viewAll : `${process.env.REACT_APP_NFT_PLATFORM_URL + '/author/' + walletAddress}`} target="_blank" className={
                                    pathname.includes('author') ? "active" : ""
                                }>
                                    <span className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28" viewBox="0 0 26 28">
                                            <g id="Group_31" data-name="Group 31" transform="translate(-2.333 -137)">
                                                <path id="Icon_material-nfc" data-name="Icon material-nfc" d="M24.6,3H5.4A2.513,2.513,0,0,0,3,5.6V26.4A2.513,2.513,0,0,0,5.4,29H24.6A2.513,2.513,0,0,0,27,26.4V5.6A2.513,2.513,0,0,0,24.6,3Z" transform="translate(0.333 135)" fill="none" stroke="#ffffff" strokeWidth="2" />
                                                <path id="Path_29" data-name="Path 29" d="M12.984,144.549H9.039v12.886h12.6V144.549H16.495a1.29,1.29,0,0,0-1.32,1.4v4.483" fill="none" stroke="#ffffff" strokeLinejoin="round" strokeWidth="2" />
                                                <g id="Ellipse_34" data-name="Ellipse 34" transform="translate(13.333 149)" fill="none" stroke="#ffffff" strokeWidth="2">
                                                    <circle cx="2" cy="2" r="2" stroke="none" />
                                                    <circle cx="2" cy="2" r="1" fill="none" />
                                                </g>
                                            </g>
                                        </svg>
                                    </span><span>My NFTs</span>
                                </a>

                                {/* </Link> */}
                            </li>
                            <li>
                                <Link to={`/profile?route=Profile`} className={
                                    pathname.includes('profile') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>
                                    <span className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28" viewBox="0 0 26 28">
                                            <g id="Icon_feather-user" data-name="Icon feather-user" transform="translate(-5 -3.5)">
                                                <path id="Path_27" data-name="Path 27" d="M30,31.5v-3a6,6,0,0,0-6-6H12a6,6,0,0,0-6,6v3" transform="translate(0 -1)" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                                <path id="Path_28" data-name="Path 28" d="M24,10.5a6,6,0,1,1-6-6,6,6,0,0,1,6,6Z" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                            </g>
                                        </svg>
                                    </span><span>My Profile</span>
                                </Link>
                            </li>
                            <li onClick={() => { handleNotifications() }}>
                                <Link to={`/notifications?route=Notifications`} className={
                                    pathname.includes('notifications') ? "active " : ""
                                } >
                                    <span className="icon notification-dot" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22.072" height="28" viewBox="0 0 22.072 28">
                                            <g id="Notification" transform="translate(1.036 1)">
                                                <path id="Stroke_1" data-name="Stroke 1" d="M10,0C3.993,0,1.383,5.5,1.383,9.141c0,2.719.39,1.919-1.1,5.236C-1.532,19.1,5.773,21.035,10,21.035s11.531-1.932,9.715-6.658c-1.488-3.317-1.1-2.517-1.1-5.236C18.618,5.5,16.006,0,10,0Z" transform="translate(0)" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                                <path id="Stroke_3" data-name="Stroke 3" d="M6.131,0A3.97,3.97,0,0,1,0,0" transform="translate(6.934 24.552)" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                            </g>
                                        </svg>
                                        {showDot === true ?
                                            <span className="icon-dot"><span className="count">{unreadNotifications ? unreadNotifications : ""}</span></span>
                                            : ""}

                                    </span><span>Notifications</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={`/settings?route=Settings`} className={
                                    pathname.includes('settings') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>
                                    <span className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26.022" height="28" viewBox="0 0 26.022 28">
                                            <g id="Setting" transform="translate(1.011 1)">
                                                <path id="Stroke_1" data-name="Stroke 1" d="M3.333,0A3.333,3.333,0,1,1,0,3.333,3.333,3.333,0,0,1,3.333,0Z" transform="translate(8.667 9.667)" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                                <path id="Stroke_3" data-name="Stroke 3" d="M23.531,6.5h0A3.538,3.538,0,0,0,18.76,5.253,2.179,2.179,0,0,1,15.493,3.41,3.453,3.453,0,0,0,12,0h0A3.453,3.453,0,0,0,8.507,3.41,2.179,2.179,0,0,1,5.24,5.253,3.54,3.54,0,0,0,.468,6.5a3.366,3.366,0,0,0,1.279,4.658,2.1,2.1,0,0,1,0,3.683A3.367,3.367,0,0,0,.468,19.5a3.54,3.54,0,0,0,4.771,1.249h0A2.178,2.178,0,0,1,8.507,22.59h0A3.453,3.453,0,0,0,12,26h0a3.453,3.453,0,0,0,3.493-3.41h0a2.178,2.178,0,0,1,3.267-1.841A3.54,3.54,0,0,0,23.531,19.5a3.366,3.366,0,0,0-1.278-4.658h0a2.1,2.1,0,0,1,0-3.683A3.366,3.366,0,0,0,23.531,6.5Z" transform="translate(0 0)" fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                            </g>
                                        </svg>
                                    </span><span>Settings</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={`/uploadContest?route=Contest`} className={
                                    pathname.includes('uploadContest') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>
                                    <span className="icon">
                                        {/* <FaVideo /> */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28.001" height="28.153" viewBox="0 0 28.001 28.153">
                                            <g id="Group_5323" data-name="Group 5323" transform="translate(14326.065 7326)">
                                                <path id="Path_7556" data-name="Path 7556" d="M207.936,16.468c-7.278-1.982-7.562-10.3-7.7-12.374S199.938,1,201.5,1h12.87c1.562,0,1.4,1.015,1.263,3.094S215.212,14.486,207.936,16.468Z" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-width="2" />
                                                <path id="Path_7557" data-name="Path 7557" d="M202.268,27l.93-5.483h9.474L213.6,27" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <line id="Line_4" data-name="Line 4" x2="15.563" transform="translate(-14319.846 -7299)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <path id="Path_7558" data-name="Path 7558" d="M209.689,15.935a7.524,7.524,0,0,0,1.349,5.581" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <path id="Path_7559" data-name="Path 7559" d="M206.182,15.935a7.524,7.524,0,0,1-1.349,5.581" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <path id="Path_7560" data-name="Path 7560" d="M200.311,6.126c-.6-3.467-5.376-3.582-5.376.342s7.092,7.384,9.373,8.111" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <path id="Path_7561" data-name="Path 7561" d="M215.56,6.126c.6-3.467,5.376-3.582,5.376.342s-7.091,7.384-9.372,8.111" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                            </g>
                                        </svg>
                                    </span><span>Contest</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={`/levels?route=Levels`} className={
                                    pathname.includes('levels') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>

                                    <span className="icon">
                                        {/* <FaRegHandSpock /> */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28.032" viewBox="0 0 26 28.032">
                                            <g id="Group_5324" data-name="Group 5324" transform="translate(14373.799 7326.016)">
                                                <path id="Path_7562" data-name="Path 7562" d="M170.675,8.806l-10.992,5.927a1.015,1.015,0,0,1-.963,0L147.728,8.806a1,1,0,0,1,0-1.757L158.72,1.122a1.015,1.015,0,0,1,.963,0l10.992,5.927A1,1,0,0,1,170.675,8.806Z" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <path id="Path_7563" data-name="Path 7563" d="M166.673,10.964l4,2.158a1,1,0,0,1,0,1.757l-10.992,5.927a1.015,1.015,0,0,1-.963,0l-10.992-5.927a1,1,0,0,1,0-1.757l4-2.158" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <path id="Path_7564" data-name="Path 7564" d="M166.673,17.036l4,2.158a1,1,0,0,1,0,1.757l-10.992,5.927a1.015,1.015,0,0,1-.963,0l-10.992-5.927a1,1,0,0,1,0-1.757l4-2.158" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                            </g>
                                        </svg>
                                    </span><span>Levels</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={`/daily-rewards?route=Daily Claim`} className={
                                    pathname.includes('daily-rewards') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>

                                    <span className="icon">
                                        {/* <BsCurrencyBitcoin className="bitcoin-icon" /> */}
                                        {/* <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g id="Layer_1-2"><path class="cls-1" d="M12.98,12.97v8.98h-1.99V12.97H3v9.03c0,1.1,.9,2,2,2h13.97c1.1,0,2-.9,2-2V12.97h-7.99Zm9.02-6.98h-3.71C20.48,3.81,19.47,.19,16.24,.01c-.07-.01-.13-.01-.2-.01-3.17,0-4.04,4.64-4.04,4.64,0,0-.87-4.64-4.04-4.64-.07,0-.13,0-.2,.01-3.23,.18-4.24,3.8-2.06,5.98H2c-1.1,0-2,.9-2,2v.99c0,1.1,.9,2,2,2H10.99v-3.99h1.99v3.99h9.02c1.1,0,2-.9,2-2v-.99c0-1.1-.9-2-2-2Zm-7.08-2.65c.11-.18,.24-.36,.36-.51,.17-.22,.4-.41,.67-.47,.19-.04,.38-.01,.56,.06,.17,.07,.34,.18,.44,.33,.26,.36,.29,1.14-.22,1.31-.41,.14-.94,.15-1.38,.22-.24,.04-.6,.13-.83,.07,.04-.34,.2-.69,.4-1Zm-7.98-.39c.03-.09,.08-.18,.14-.26,.17-.21,.45-.3,.72-.34,.09-.01,.19-.02,.28,0,.22,.04,.4,.2,.54,.37,.21,.24,.38,.51,.52,.79,.13,.26,.31,.58,.36,.87-.28-.07-.58-.08-.86-.12-.31-.05-.61-.1-.92-.14-.2-.03-.46,0-.63-.14-.19-.16-.22-.57-.2-.79,0-.08,.02-.16,.05-.23Z" /></g></svg> */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28" viewBox="0 0 26 28">
                                            <g id="Group_5326" data-name="Group 5326" transform="translate(14520 7326)">
                                                <rect id="Rectangle_1023" data-name="Rectangle 1023" width="24" height="5.224" transform="translate(-14519 -7318.032)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <path id="Path_7553" data-name="Path 7553" d="M4.118,13.193V25a2,2,0,0,0,2,2H19.767a2,2,0,0,0,2-2V13.193" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <line id="Line_3" data-name="Line 3" y2="13.808" transform="translate(-14507 -7312.808)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <path id="Path_7554" data-name="Path 7554" d="M13,7.968S14.251,1,18.445,1,21.969,7.968,13,7.968Z" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <path id="Path_7555" data-name="Path 7555" d="M13,7.968S11.749,1,7.555,1,4.031,7.968,13,7.968Z" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                            </g>
                                        </svg>
                                    </span><span>Daily claim</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={`/user-referrals?route=Referrals`} className={
                                    pathname.includes('/user-referrals') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>
                                    <span className="icon">
                                        {/* <BsCurrencyBitcoin className="bitcoin-icon" /> */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                                            <g id="Group_5325" data-name="Group 5325" transform="translate(14472 7326)">
                                                <path id="Path_7565" data-name="Path 7565" d="M2.979,16.717q-.023-.355-.023-.716A11,11,0,0,1,9.674,5.865" transform="translate(-14472 -7326)" fill="none" stroke="#ffffff" stroke-width="2" />
                                                <path id="Path_7566" data-name="Path 7566" d="M22.329,23.135a11,11,0,0,1-15.967.823" transform="translate(-14472 -7326)" fill="none" stroke="#ffffff" stroke-width="2" />
                                                <path id="Path_7567" data-name="Path 7567" d="M17.942,5.744a11,11,0,0,1,7.009,9.919" transform="translate(-14472 -7326)" fill="none" stroke="#ffffff" stroke-width="2" />
                                                <circle id="Ellipse_51" data-name="Ellipse 51" cx="4.02" cy="4.02" r="4.02" transform="translate(-14462.03 -7325)" fill="none" stroke="#ffffff" stroke-width="2" />
                                                <circle id="Ellipse_52" data-name="Ellipse 52" cx="4.02" cy="4.02" r="4.02" transform="translate(-14471 -7309.853)" fill="none" stroke="#ffffff" stroke-width="2" />
                                                <circle id="Ellipse_53" data-name="Ellipse 53" cx="4.02" cy="4.02" r="4.02" transform="translate(-14453.04 -7310.853)" fill="none" stroke="#ffffff" stroke-width="2" />
                                            </g>
                                        </svg>
                                    </span><span>Referrals</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={`/sell/avatars?route=Sell Avatar`} className={
                                    pathname.includes('/sell/avatars') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>
                                    <span className="icon">
                                        {/* <BsCurrencyBitcoin className="bitcoin-icon" /> */}
                                        <svg id="Layer_1-2" xmlns="http://www.w3.org/2000/svg" width="28" height="28.037" viewBox="0 0 28 28.037">
                                            <rect id="Rectangle_1042" data-name="Rectangle 1042" width="26" height="26" rx="4" transform="translate(1 1)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                            <path id="Path_7571" data-name="Path 7571" d="M22.52,27s.14-3.68.22-4.62a2.409,2.409,0,0,0-1.46-2.54l-4.47-1.1L14,21.8l-2.81-3.06-4.47,1.1a2.4,2.4,0,0,0-1.46,2.54c.09.94.22,4.62.22,4.62" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                            <path id="Path_7572" data-name="Path 7572" d="M14,16.35c-1.86,0-2.75-1.25-3.5-4.21S10,5.95,14,5.95s4.25,3.23,3.5,6.19S15.86,16.35,14,16.35Z" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                        </svg>

                                    </span><span>Sell Avatar</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={`/sell/badges?route=Sell Badge`} className={
                                    pathname.includes('/sell/badges') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>
                                    <span className="icon">
                                        {/* <BsCurrencyBitcoin className="bitcoin-icon" /> */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22.061" height="28.055" viewBox="0 0 22.061 28.055">
                                            <g id="Layer_1-2" transform="translate(-0.01 0.005)">
                                                <path id="Path_7573" data-name="Path 7573" d="M11.05,19.38c-1.28,0-2.39,2.28-4.15,1.52s-.63-3.4-1.93-4.21c-1-.63-3.4.07-3.85-1.64s1.41-2.37,1.58-3.78S.74,8.63,1.17,6.87c.44-1.49,3.09-.7,4.05-1.85S5.44,1.05,7.4,1.05c1.61,0,2.88,1.6,3.64,1.6s2.02-1.6,3.64-1.6c1.96,0,1.22,2.83,2.18,3.97s3.62.35,4.05,1.85c.44,1.76-1.7,2.99-1.53,4.4s2.04,2.07,1.58,3.78-2.84,1.01-3.85,1.64c-1.31.81-.18,3.45-1.93,4.21s-2.87-1.52-4.15-1.52Z" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.11" />
                                                <path id="Path_7574" data-name="Path 7574" d="M15.55,24.05v3l-4.5-1.87-4.5,1.87v-3" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                                <g id="Path_7575" data-name="Path 7575" fill="none">
                                                    <path d="M11.05,6.68a1,1,0,0,0-.84.45L9.54,8.15a1.038,1.038,0,0,1-.58.42l-1.05.28a1,1,0,0,0-.46,1.66l.64.67a1.015,1.015,0,0,1,.27.86l-.21,1.23a1,1,0,0,0,.98,1.17,1.013,1.013,0,0,0,.41-.09l1.08-.49a.979.979,0,0,1,.82,0l1.08.49a1.049,1.049,0,0,0,.41.09,1,1,0,0,0,.98-1.17l-.21-1.23a1.015,1.015,0,0,1,.27-.86l.64-.67a1,1,0,0,0-.46-1.66L13.1,8.57a.983.983,0,0,1-.58-.42l-.67-1.02a1,1,0,0,0-.84-.45h0Z" stroke="none" />
                                                    <path d="M 11.01000022888184 6.679999351501465 L 11.05000114440918 6.679999351501465 C 11.03668212890625 6.679999351501465 11.02332401275635 6.679999351501465 11.01000022888184 6.679999351501465 Z M 11.03000068664551 6.680194854736328 C 11.34328937530518 6.686308860778809 11.6541633605957 6.836243629455566 11.85000038146973 7.129999160766602 L 12.52000045776367 8.149999618530273 C 12.66000080108643 8.359999656677246 12.86000061035156 8.50999927520752 13.10000038146973 8.569999694824219 L 14.15000057220459 8.84999942779541 C 14.89000129699707 9.049999237060547 15.14000129699707 9.959999084472656 14.61000061035156 10.50999927520752 L 13.97000026702881 11.17999935150146 C 13.75000095367432 11.40999984741211 13.65000057220459 11.72999954223633 13.70000076293945 12.03999900817871 L 13.91000080108643 13.26999950408936 C 14.02000045776367 13.90999984741211 13.52000045776367 14.4399995803833 12.93000030517578 14.4399995803833 C 12.80000114440918 14.4399995803833 12.66000080108643 14.40999984741211 12.52000045776367 14.34999942779541 L 11.44000053405762 13.85999965667725 C 11.18000030517578 13.73999881744385 10.88000106811523 13.73999881744385 10.6200008392334 13.85999965667725 L 9.540000915527344 14.34999942779541 C 9.40000057220459 14.40999984741211 9.270000457763672 14.4399995803833 9.130001068115234 14.4399995803833 C 8.55000114440918 14.4399995803833 8.040000915527344 13.90999984741211 8.15000057220459 13.26999950408936 L 8.360000610351562 12.03999900817871 C 8.410000801086426 11.72999954223633 8.310000419616699 11.40999984741211 8.090001106262207 11.17999935150146 L 7.450000762939453 10.50999927520752 C 6.920001029968262 9.959999084472656 7.170001029968262 9.049999237060547 7.910000801086426 8.84999942779541 L 8.960000991821289 8.569999694824219 C 9.200000762939453 8.499999046325684 9.410000801086426 8.34999942779541 9.540000915527344 8.149999618530273 L 10.21000099182129 7.129999160766602 C 10.40583801269531 6.836243629455566 10.71671199798584 6.686308860778809 11.03000068664551 6.680194854736328 Z" stroke="none" fill="#ffffff" />
                                                </g>
                                            </g>
                                        </svg>
                                    </span><span>Sell Badges</span>
                                </Link>
                            </li>
                            <li>
                                <a href={process.env.REACT_APP_TREASUREBOX_URL} target="_blank" className={
                                    pathname.includes('/posts') ? "active " : ""
                                } onClick={(e) => checkWallet(e)}>

                                    <span className="icon">
                                        {/* <GiOpenTreasureChest className="bitcoin-icon" /> */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="26" viewBox="0 0 28 26">
                                            <g id="treasure-icon" transform="translate(1 1)">
                                                <path id="Path_41" data-name="Path 41" d="M5.873,1C2.111,1,1,5.671,1,8.214V25H27V8.214C27,5.671,25.889,1,22.127,1Z" transform="translate(-1 -1)" fill="none" stroke="#ffffff" stroke-width="2" />
                                                <path id="Path_42" data-name="Path 42" d="M7.028,1C6.486,1,5.5,2.791,5.5,5h12c0-2.209-.986-4-1.528-4" transform="translate(1.5 -1)" fill="none" stroke="#ffffff" stroke-width="2" />
                                                <path id="Path_43" data-name="Path 43" d="M7.991,10.615H4v8H20v-8H15.991" transform="translate(1 1.385)" fill="none" stroke="#ffffff" stroke-width="2" />
                                                <line id="Line_1" data-name="Line 1" x2="26" transform="translate(0 8)" fill="none" stroke="#ffffff" stroke-width="2" />
                                                <rect id="Rectangle_66" data-name="Rectangle 66" width="7" height="7" transform="translate(9.49 8)" fill="none" stroke="#ffffff" stroke-width="2" />
                                            </g>
                                        </svg>
                                    </span><span>Treasure Box</span>
                                </a>
                            </li>
                            {/* <li>
                            <span onClick={specialNotesModal}>
                                <a
                                >
                                    <span className="icon">
                                        <GiOpenTreasureChest className="bitcoin-icon" />
                                    </span><span>Special Notes</span>
                                </a>
                            </span>
                        </li> */}
                            {notesModal ?
                                <NotesModal notesModalClose={notesModalClose} /> : ""
                            }
                            {/* <li>
                            <Link to={`/contest/details`} className={
                                pathname.includes('daily-rewards') ? "active " : ""
                            }>

                                    <span className="icon">
                                    <BsCurrencyBitcoin className="bitcoin-icon"/>
                                    </span>Contest Details
                                </Link>
                            </li> */}
                            <li>
                                <a className="" onClick={() => { logout() }} >
                                    <span className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28">
                                            <g id="Group_5327" data-name="Group 5327" transform="translate(14421.532 7326)">
                                                <path id="Path_7551" data-name="Path 7551" d="M116.807,10.021V5a4,4,0,0,0-4-4h-9.339a4,4,0,0,0-4,4V23a4,4,0,0,0,4,4H114.11" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-width="2" />
                                                <line id="Line_2" data-name="Line 2" x2="14.36" transform="translate(-14412.893 -7307.276)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-width="2" />
                                                <path id="Path_7552" data-name="Path 7552" d="M117.539,22.511l3.929-3.787-3.929-3.786" transform="translate(-14520 -7326)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-width="2" />
                                            </g>
                                        </svg>
                                    </span>Logout
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* </div> */}
            </div>
        </>
    );
}

export default Sidebar;
